<template>
<div class="deviceNoBind">
   <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span style="line-height: 36px;">未激活设备</span>
      <div style="float:right">
        <el-input placeholder="昵称/地址" v-model="keyWord" @keyup.enter.native="getDeviceList">
          <el-select v-model="sltValue" slot="prepend" placeholder="请选择">
            <el-option label="设备编号" value="0"></el-option>
            <el-option label="设备昵称" value="1"></el-option>
            <el-option label="设备地址" value="2"></el-option>
          </el-select>
          <el-button slot="append" icon="search" @click="getDeviceList"></el-button>
        </el-input>
      </div>
      <el-button style="float: left;margin-right:20px;" type="success" v-if="userType==0||userType==1" @click="allotDevice">分配设备</el-button>
    </div>
    <div>
      <el-table
      v-loading="table_loading"
      element-loading-text="拼命加载中"
      :data="deviceData"
      stripe
      border
      fit
      height="520"
      @selection-change="handleSelectionChange"
      style="width: 100%">
      <el-table-column
        prop="id"
        type="selection"
        width="40">
      </el-table-column>
      <el-table-column
        prop="num"
        header-align="center"
        width="165"
        label="设备编号">
      </el-table-column>
      <el-table-column
        prop="name"
        header-align="center"
        min-width="100"
        label="设备昵称">
      </el-table-column>
      <el-table-column
        prop="user_type"
        header-align="center"
        min-width="95"
        label="账号类型">
      </el-table-column>
      <el-table-column
        prop="owner"
        header-align="center"
        min-width="100"
        label="设备所属">
      </el-table-column>
      <el-table-column
        prop="payStatus"
        header-align="center"
        min-width="90"
        v-if="userType == 0"
        label="流程">
        <template scope="scope">
          <el-popover
            ref="popoverPayStatus1"
            placement="top-start"
            width="200"
            trigger="hover">
            <h4 style="text-align: center;">取货流程{{scope.row.payStatus}}</h4>
            <p>{{payStatusDes(scope.row.payStatus)}}</p>
          </el-popover>
          <span style="padding: 5px 10px;" v-popover:popoverPayStatus1>{{scope.row.payStatus}}</span>
          <i class="el-icon-edit" @click="popEditP(scope.row.num,scope.row.payStatus,scope.row.payPoints,scope.row.payCharge)"></i>
        </template>
      </el-table-column>
      <el-table-column
        prop=""
        header-align="center"
        min-width="120"
        v-if="userType == 2"
        label="价格">
        <template scope="scope">
          <span style="padding: 5px 10px;">{{scope.row.payCharge}}</span>
          <i class="el-icon-edit" @click="popEditPrice(scope.row.num,scope.row.payCharge)"></i>
        </template>
      </el-table-column>
      <el-table-column
        prop="spase"
        header-align="center"
        min-width="95"
        label="所在场景">
      </el-table-column>
      <el-table-column
        prop="address"
        header-align="center"
        min-width="150"
        label="设备地址">
      </el-table-column>
      <el-table-column
        prop="status"
        header-align="center"
        width="80"
        label="状态">
        <template scope="scope">
        <el-tag :type="scope.row.status === '离线' ? 'danger' : 'success'"
        close-transition>{{scope.row.status}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="pager"
        header-align="center"
        width="130"
        label="商品量">
        <template scope="scope">
        <span v-if="scope.row.pager/scope.row.paperVolume > 0.75" 
        style="color:#13CE66">{{scope.row.pager}}/{{scope.row.paperVolume}}</span>
        <span v-else-if="scope.row.pager/scope.row.paperVolume > 0.50" 
        style="color:#b8ce13">{{scope.row.pager}}/{{scope.row.paperVolume}}</span>
        <span v-else-if="scope.row.pager/scope.row.paperVolume > 0.25" 
        style="color:#F7BA2A">{{scope.row.pager}}/{{scope.row.paperVolume}}</span>
        <span v-else 
        style="color:#FF4949">{{scope.row.pager}}/{{scope.row.paperVolume}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="see"
        header-align="center"
        width="240"
        label="查看">
        <template scope="scope">
            <el-button 
                @click="seeNext('ad', scope.row.num)"
                type="text" size="small">
                广告
            </el-button>
            <el-button
                @click="seeNext('weixin', scope.row.num)" 
                type="text" size="small">公众号</el-button>
            <el-button
                @click="seeNext('deviceInfo', scope.row.num)" 
                type="text" size="small">设备信息</el-button>
            <el-button @click="seeNext('pageRecord', scope.row.num)" type="text" size="small">补货记录</el-button>
        </template>
      </el-table-column>
    </el-table>
    </div>
    <div class="table_pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal">
      </el-pagination>
    </div>
  </el-card>
  <po-allot-device v-if="allotDeviceShow" :add-show="show" :allot-params="multipleSelection" :device-id="deviceId" @closeAllotAccount="closeAllot"></po-allot-device>
  <pu-see-pop-right 
    v-if="seeShow"
    :see-pop-right-ok="seePopRightOk" 
    :device-code="deviceCode"
    :see-type = 'seeType'
    @closeSeeRightPop="closeSeeRightPop">
  </pu-see-pop-right>
  <pu-edit-pop 
    :add-show="myEditPopShow" 
    :edit-dvce-code="deviceCode"
    :edit-status="eStatus"  
    :edit-points="ePoints"  
    :edit-price="ePrice"
    @closeEditPoint="closeEditP"></pu-edit-pop>
    <pu-edit-price 
    :add-show="myEditPriceShow" 
    :edit-dvce-code="deviceCode"
    :edit-price="ePrice"
    @closeEditPrice="closeEditPrice"></pu-edit-price>
  </div>
</template>
<script>
    import $axios from '../../https/config'
    import puSeePopRight from '@/page/deviceMgr/seePopRight'
    import puEditPrice from '@/page/deviceMgr/editPrice'
    import puEditPop from '@/page/deviceMgr/editPoint'
    import poAllotDevice from '@/page/deviceMgr/allotDevice'
    import {isNull} from '../../js/tool'

    export default {
      data () {
        return {
          deviceData: [],
          pageTotal: 0,
          pageSize: 10,
          myEditPopShow: false,
          myEditPriceShow: false,
          deviceCode: '',
          eStatus: '',
          ePoints: '',
          ePrice: '',
          pageNo: 1,
          sltValue: '0',
          spaceTypeList: '',
          ownerType: '',
          keyWord: '',
          show: false,
          userType: this.$store.state.userType,
          multipleSelection: '',
          deviceId: '',
          table_loading: false,
          allotDeviceShow: false,
          seeShow: false,
          seePopRightOk: false,
          seeType: ''
        }
      },
      created: function () {
        this.pageNo = 1
        this.getSpaseTypeList()
      },
      methods: {
        getSpaseTypeList () {
          var _this = this
          $axios.get('/device/getDeviceIndustry', null, 'headers', function (res) {
            if (res && res.resultStatus === true) {
              _this.$store.state.spaceDataList = res.resultData.list
              _this.spaceTypeList = _this.$store.state.spaceDataList
              _this.queryDeviceList(_this.pageNo, _this.pageSize, '')
            }
          })
        },
        queryDeviceList (tPageNo, tPageSize, tttt) {
          var _this = this
          var params = {
            pageNo: tPageNo,
            pageSize: tPageSize,
            isAssigned: 0
          }
          this.table_loading = true
          this.deviceData = []
          $axios.get('/device/getDeviceList', params, 'headers', function (res) {
            if (res && res.resultStatus === true) {
              var resData = []
              if (res.resultData && res.resultData.list.length > 0) {
                _this.pageTotal = res.resultData.count
                for (var i = 0; i < res.resultData.list.length; i++) {
                  var itemData = res.resultData.list[i]
                  var mType = '---'
                  if (itemData.user_type === 0) {
                    mType = '超级管理员'
                  } else if (itemData.user_type === 1) {
                    mType = '代理商'
                  } else if (itemData.user_type === 2) {
                    mType = '设备主'
                  } else if (itemData.user_type === 3) {
                    mType = '维护人员'
                  } else if (itemData.user_type === 4) {
                    mType = '商户'
                  } else if (itemData.user_type === 5) {
                    mType = '销售'
                  }
                  var item = {
                    id: itemData.id,
                    num: itemData.deviceCode,
                    name: itemData.alias,
                    owner: itemData.nickName,
                    address: itemData.address,
                    payStatus: isNull(itemData.devicePoint) ? '5' : itemData.devicePoint.status,
                    payPoints: isNull(itemData.devicePoint) ? '' : itemData.devicePoint.point,
                    payCharge: isNull(itemData.devicePoint) ? '' : itemData.devicePoint.charge,
                    locationRoom: itemData.locationRoom,
                    spase: _this.getDeviceSpaceValue(_this.spaceTypeList, itemData.ownerType),
                    supplementNum: itemData.supplementNum,
                    status: itemData.isOnline === 0 ? '离线' : '在线',
                    pager: itemData.paperNum,
                    paperVolume: itemData.paperVolume,
                    user_type: mType
                  }
                  resData.push(item)
                }
                _this.deviceData = resData
              }
            } else {
            }
            _this.table_loading = false
          }, function () {
          })
        },
        handleSizeChange (val) {
          this.pageSize = val
          if (this.keyWord === '') {
            this.queryDeviceList(this.pageNo, this.pageSize)
          } else {
            this.searchDevice(this.pageNo, this.pageSize)
          }
        },
        handleCurrentChange (val) {
          this.pageNo = val
          if (this.keyWord === '') {
            this.queryDeviceList(this.pageNo, this.pageSize)
          } else {
            this.searchDevice(this.pageNo, this.pageSize)
          }
        },
        handleSelectionChange (selection) {
          this.multipleSelection = ''
          this.deviceId = ''
          for (var i = 0; i < selection.length; i++) {
            this.multipleSelection += (selection[i].num + '|')
            this.deviceId += (selection[i].id + '|')
          }
        },
        getDeviceSpaceValue (items, index) {
          var returnData
          if (isNull(index) || isNull(items)) {
            returnData = '无'
          } else {
            for (var i = 0; i < items.length; i++) {
              if (index === items[i].id) {
                returnData = items[i].name
              }
            }
          }
          return returnData
        },
        selectSeeItem (command) {
          if (command === 'ad') {
            this.$message('click on itme ' + '广告')
          } else if (command === 'weixin') {
            this.$message('click on itme ' + '公众号')
          } else if (command === 'record') {
            this.$message('click on itme ' + '补货记录')
          } else if (command === 'details') {
            this.$message('click on itme ' + '设备详情')
          }
        },
        popEditP (code, status, po, pr) {
          this.deviceCode = code
          this.eStatus = status
          this.ePoints = po
          this.ePrice = pr
          this.myEditPopShow = true
        },
        popEditPrice (code, pr) {
          this.deviceCode = code
          this.ePrice = pr
          this.myEditPriceShow = true
        },
        closeEditP () {
          this.myEditPopShow = false
        },
        closeEditPrice () {
          this.myEditPriceShow = false
          if (isNull(this.searchValue)) {
            this.queryDeviceList(this.pageNo, this.pageSize, '')
          } else {
            this.queryDeviceListByKey(this.searchSelect, this.searchValue, this.pageNo, this.pageSize)
          }
        },
        seeNext (mSeeType, mDeviceCoe) {
          this.deviceCode = mDeviceCoe
          this.seeType = mSeeType
          this.seePopRightOk = true
          this.seeShow = true
        },
        closeSeeRightPop () {
          this.seePopRightOk = false
          if (isNull(this.keyWord)) {
            this.queryDeviceList(this.pageNo, this.pageSize)
          } else {
            this.searchDevice(this.pageNo, this.pageSize)
          }
        },
        closeAllot () {
          this.show = false
          this.allotDeviceShow = false
          this.queryDeviceList(this.pageNo, this.pageSize)
        },
        getDeviceList () {
          this.pageNo = 1
          if (this.keyWord === '') {
            this.queryDeviceList(this.pageNo, this.pageSize)
          } else {
            this.searchDevice(this.pageNo, this.pageSize)
          }
        },
        searchDevice (tPageNo, tPageSize) {
          var _this = this
          _this.table_loading = true
          this.deviceData = []
          var params = {
            type: _this.sltValue,
            keyword: _this.keyWord,
            pageNo: tPageNo,
            pageSize: tPageSize,
            isAssigned: 0
          }
          $axios.get('/device/query', params, 'headers', function (res) {
            if (res && res.resultStatus === true) {
              var resData = []
              if (res.resultData && res.resultData.list.length > 0) {
                _this.pageTotal = res.resultData.count
                for (var i = 0; i < res.resultData.list.length; i++) {
                  var itemData = res.resultData.list[i]
                  var mType = '---'
                  if (itemData.user_type === 0) {
                    mType = '超级管理员'
                  } else if (itemData.user_type === 1) {
                    mType = '代理商'
                  } else if (itemData.user_type === 2) {
                    mType = '设备主'
                  } else if (itemData.user_type === 3) {
                    mType = '维护人员'
                  } else if (itemData.user_type === 4) {
                    mType = '商户'
                  } else if (itemData.user_type === 5) {
                    mType = '销售'
                  }
                  var item = {
                    id: itemData.id,
                    num: itemData.deviceCode,
                    name: itemData.alias,
                    owner: itemData.nickName,
                    payStatus: isNull(itemData.devicePoint) ? '5' : itemData.devicePoint.status,
                    payPoints: isNull(itemData.devicePoint) ? '' : itemData.devicePoint.point,
                    payCharge: isNull(itemData.devicePoint) ? '' : itemData.devicePoint.charge,
                    address: itemData.address,
                    locationRoom: itemData.locationRoom,
                    supplementNum: itemData.supplementNum,
                    status: itemData.isOnline === 0 ? '离线' : '在线',
                    pager: itemData.paperNum,
                    paperVolume: itemData.paperVolume,
                    user_type: mType
                  }
                  resData.push(item)
                }
                _this.deviceData = resData
              }
            } else {
            }
            _this.table_loading = false
          })
        },
        allotDevice () {
          var that = this
          if (that.multipleSelection.length === 0) {
            that.$message({
              type: 'warning',
              duration: 1000 * 5,
              message: '请选择要分配的设备!'
            })
            return false
          }
          that.allotDeviceShow = true
          that.show = true
        },
        changeSortType () {
        },
        payStatusDes (num) {
          var payStatusDesValue = [{
            key: 0,
            value: '文章标准'
          }, {
            key: 1,
            value: '文章纯积分'
          }, {
            key: 2,
            value: '支付页购买'
          }, {
            key: 3,
            value: '承德888'
          }, {
            key: 4,
            value: '支付无页面'
          }, {
            key: 5,
            value: '长按标准'
          }, {
            key: 6,
            value: '无屏支付'
          }, {
            key: 7,
            value: '长按每天一包'
          }, {
            key: 8,
            value: '无屏长按每天一包'
          }, {
            key: 9,
            value: '测试有屏幕的纯支付'
          }]
          var returnData
          if (num === '无') {
            returnData = '未知流程'
          } else {
            if (num >= payStatusDesValue.length) {
              returnData = '未知流程'
            } else {
              returnData = payStatusDesValue[num].value
            }
          }
          return returnData
        }
      },
      components: {
        'po-allot-device': poAllotDevice,
        'pu-edit-pop': puEditPop,
        'pu-see-pop-right': puSeePopRight,
        'pu-edit-price': puEditPrice
      }
    }
</script>
<style lang="scss">
    .table_pagination {
      text-align: right;
      margin-top: 10px; 
    }
    .deviceNoBind {
        .el-select .el-input {
          width: 110px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/page/deviceMgr/deviceNoBind.vue